<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-card flat>
          <v-card-title class='headline my-4'>Pre-Design Embodied Carbon Calculator</v-card-title>
          <v-card-subtitle>A quick means of creating bespoke project targets</v-card-subtitle>
          <v-card-subtitle>Note: the pre-design embodied carbon calculator currently works for building elements only. 
          The calculator shall be updated in due course to consider infrastructure elements as well.</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <CalculatorMain />
      </v-col>
    </v-row>
  </v-container> 
</template>

<script>
import CalculatorMain from '@/components/CalculatorMain'

export default {
  components: {
    CalculatorMain,
  }
    
}
</script>